import http from './http';
import { AnkorAgentTaskResponse, RunCrmTaskPayload } from '@monolith/legacy/types/ankoragent';

const rootUrl = '/api/ankoragent/v1/tasks';

export const runCrmTask = async (payload: RunCrmTaskPayload): Promise<AnkorAgentTaskResponse> => {
  return http()
    .post(`${rootUrl}/${payload.task}/executions`, {
      parameters: {
        task: payload.task,
        language: payload.language,
        messagesURL: payload.messagesURL,
        contactURL: payload.catalogueLink,
        freeDeliveryThreshold: payload.freeDeliveryThreshold,
        discount: payload.discount?.toString(),
        targetCountries: payload.targetCountries.join(', '),
        additionalInstructions: payload.additionalInstructions || '',
        retailerName: payload.retailerName || 'none',
        products: payload.products ? JSON.stringify(payload.products) : 'none',
      },
    })
    .then((response) => response.data)
};